/**
 * Format a date with various patterns
 * @param date The date to format
 * @param format Optional format pattern (DD/MM/YYYY by default)
 * @returns Formatted date string
 */
export const formatDate = (date: Date, format: string = 'DD/MM/YYYY'): string => {
  if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
    return '';
  }

  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();

  let result = format;
  result = result.replace('DD', day);
  result = result.replace('MM', month);
  result = result.replace('YYYY', year.toString());

  return result;
};
